import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@material-ui/core'

import LogoWithText from 'assets/images/token/titleimg.png'
import Button1 from 'assets/images/token/join.png'
import Emo1 from 'assets/images/token/1.png'
import Emo2 from 'assets/images/token/2.png'
import Emo3 from 'assets/images/token/3.png'
import Emo4 from 'assets/images/token/4.png'
import Emo5 from 'assets/images/token/5.png'
import Emo6 from 'assets/images/token/6.png'
import StaticSnow1 from 'assets/images/token/static1.png'
import StaticSnow2 from 'assets/images/token/static2.png'
import StaticSnow3 from 'assets/images/token/static3.png'
import StaticSnow4 from 'assets/images/token/static4.png'
import StaticSnow5 from 'assets/images/token/static5.png'
import useWindowDimensions from 'hooks/useDimensions'
// import { useHistory } from 'react-router'

interface Props {
    mainRef: any
}

const Token: React.FC<Props> = ({ mainRef }) => {
    const screenWidth = useWindowDimensions().width
    const [isMobile, setIsMobile] = useState(false)
    // const history = useHistory()

    useEffect(() => {
        screenWidth > 767 ? setIsMobile(false) : setIsMobile(true)
    }, [screenWidth])
    return (
        <StyledContainer>
            <img ref={mainRef} src={LogoWithText} width='380px' alt='' />
            <Text mt='17.76px' maxWidth={isMobile ? '293px' : 'unset'}>
                You can get the first token on Frozen Exchange. The pre-sale start soon!
            </Text>
            <CardContainer>
                <Card>
                    <Box>
                        <Box>
                            <img src={Emo1} alt='' />
                        </Box>
                        <YellowText>100M</YellowText>
                        <Text mt='9px' display='flex' flexDirection='column' justifyContent='center'>Total supply</Text>
                    </Box>
                    <Box>
                        <Box>
                            <img src={Emo2} alt='' />
                        </Box>
                        <YellowText>75%</YellowText>
                        <Text mt='9px' display='flex' flexDirection='column' justifyContent='center'>Farm & Pools</Text>
                    </Box>
                    <Box>
                        <Box pt={1.5}>
                            <img src={Emo3} alt='' />
                        </Box>
                        <YellowText>9%</YellowText>
                        <Text mt='9px' display='flex' flexDirection='column' justifyContent='center'>Public sale</Text>
                    </Box>
                </Card>
                <Card>
                    <Box mt={1}>
                        <Box>
                            <img src={Emo4} alt='' />
                        </Box>
                        <YellowText>5%</YellowText>
                        <Text mt='9px' display='flex' flexDirection='column' justifyContent='center'>Liquidity</Text>
                    </Box>
                    <Box pt={4.5}>
                        <Box>
                            <img src={Emo5} alt='' />
                        </Box>
                        <YellowText>10%</YellowText>
                        <Text mt='9px' display='flex' flexDirection='column' justifyContent='center' maxWidth='124px'>Team & Advisors</Text>
                    </Box>
                    <Box mt={1}>
                        <Box>
                            <img src={Emo6} alt='' />
                        </Box>
                        <YellowText>1%</YellowText>
                        <Text mt='9px' display='flex' flexDirection='column' justifyContent='center'>Airdrop</Text>
                    </Box>
                </Card>
            </CardContainer>
            <Box display='flex' justifyContent='center'>
                <JoinButton component='img' {...{ src: Button1 }} onClick={() => window.open('https://forms.gle/iwBvomru7fupQxKq7')}/>
            </Box>
            <Unknown width='100%'>
                <img src={StaticSnow1} alt='' />
                <img src={StaticSnow2} alt='' />
                <img src={StaticSnow3} alt='' />
                <img src={StaticSnow4} alt='' />
                <img src={StaticSnow5} alt='' />
                <video src='/video/elsa.mp4' autoPlay muted loop width='100%' />
            </Unknown>
        </StyledContainer>
    )
}

const Unknown = styled(Box)`
    margin-top: 49px;
    display: flex;
    @media (max-width: 767px) {
        margin-top: 87px;
    }
    position: relative;
    >img:first-of-type {
        margin-top: -75px;
        position: absolute;
        width: 100%;
        @media (max-width: 767px) {
            display: none;
        }
    }
    >img:nth-of-type(2) {
        position: absolute;
        bottom: -31%;
        right: 0;
        width: 100%;
        @media (max-width: 767px) {
            display: none;
        }
    }
    >img:nth-of-type(3) {
        position: absolute;
        bottom: -23%;
        right: 2.5%;
        width: calc(97.5% - 73px);
        @media (max-width: 767px) {
            display: none;
        }
    }
    >img:nth-of-type(4) {
        position: absolute;
        top: -20%;
        width: 110%;
        transform: translateX(-10%);
        @media (min-width: 767px) {
            display: none;
        }
        @media (max-width: 360px) {
            display: none;
        }
    }
    >img:nth-of-type(5) {
        position: absolute;
        bottom: -9%;
        width: 100%;
        @media (min-width: 767px) {
            display: none;
        }
    }
`

const YellowText = styled(Box)`
    margin-top: 20.24px;
    @media (max-width:767px) {
        margin-top: 18px;
    }
    font-weight: bold;
    font-size: 40px;
    line-height: 60px;
    text-align: center;
    color: #E4B01E;
`

const Card = styled(Box)`
    background: rgba(255, 255, 255, 0.67);
    border-radius: 40px;
    width: 609px;
    height: 326px;
    display: flex;
    justify-content: center;
    align-items: center;
    >div {
        display: flex;
        flex-direction:column;
        align-items: center;
    }
    >div >div:first-of-type{
        @media (min-width:767px) {
            min-height: 76px;
        }
    }
    >div+div {
        margin-left: 47px;
        margin-top: 0;
    }
    @media (max-width: 767px) {
        height: auto;
        padding: 52px 0;
        width: 100%;
        flex-direction: column;
        >div+div {
            margin-left: 0;
            margin-top: 46px;
        }
    }
`

const JoinButton = styled(Box)`
    height: 84px;
    pointer-events: initial;
    cursor: pointer;
`

const CardContainer = styled(Box)`
    margin-top: 56px;
    margin-bottom: 28px;
    display: flex;
    >div+div {
        margin-left: 38px;
        margin-top: 0;
    }
    @media (max-width: 1439px) {
        flex-direction: column;
        align-items: center;
        width: calc(100% - 45px);
        >div+div {
            margin-left: 0;
            margin-top: 30px;
        }
    }
    @media (max-width: 390px) {
        margin-top: 37px;
        width: calc(100% - 70px);
    }
`

const Text = styled(Box)`
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #000000;
`

const StyledContainer = styled(Box)`
    margin-top: 250px;
    @media (max-width: 600px) {
        margin-top: 82px;
    }
    @media (max-width: 360px) {
        margin-top: 45.34px;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    >img {
        @media (max-width: 767px) {
            width: 300px;
        }
    }
`

export default Token